export function scriptTagLoader(url: string) {
    const scripts = Array.from(document.querySelectorAll("script"));

    if (scripts.find(s => s.src === url)) {
        return;
    }

    const tag = document.createElement("script");
    tag.type = "text/javascript";
    tag.src = url;

    document.querySelector("body").append(tag);
}

export function cssTagLoader(url: string) {
    const cssFiles = Array.from(document.querySelectorAll("link"));

    if (cssFiles.find(s => s.href === url)) {
        return;
    }

    const tag = document.createElement("link");
    tag.rel = "stylesheet";
    tag.href = url;

    document.querySelector("body").append(tag);
}